<template>
  <div>
    <v-tooltip bottom v-if="check">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          rounded
          v-on="on"
          @click="generateMenage()"
        >
          Générer ménage
        </v-btn>
      </template>
      <span>Générer ménage</span>
    </v-tooltip>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  created() {
    this.CheckIfMenageExists();
  },
  props: {
    idMenage: {
      required: true,
    },
    membre: {
      required: true,
    },
    groupe: {
      required: true,
    },
  },
  data() {
    return {
      menageDone: false,
      check: false,
    };
  },
  methods: {
    //insertMenage
    ...mapActions({
      insertMenage: "Utils/insertMenage",
    }),

    CheckIfMenageExists() {
      var self = this;
      // MenagesDuSuperviseur
      var exists = _.filter(self.MenagesDuSuperviseur, {
        id: self.idMenage,
      });

      if (exists.length < 1) {
        this.check = true;
      }
    },
    generateMenage() {
      var self = this;
      var objetMenage = this.membre;
      objetMenage.nomMembrePrincipal = this.membre.nom;
      delete objetMenage.actif_dans_groupe;
      delete objetMenage.annee_naissance;
      delete objetMenage.date_insert_membre;
      delete objetMenage.membre_gec;
      delete objetMenage.nom;
      delete objetMenage.raison_inactivite;
      delete objetMenage.sexe;
      objetMenage.dateGenerationMenage = self
        .$moment(Date.now())
        .format("YYYY-MM-DD HH:mm:ss");
      objetMenage.projectList = self.groupe.projectList;
      objetMenage.projets = self.groupe.projets;
      //code_menage
      objetMenage.id = self.membre.code_menage;
      objetMenage.ll_menage = self.membre.code_menage;
      this.insertMenage(objetMenage);
      this.check = false;
    },
  },
  computed: {
    ...mapState({
      MenagesDuSuperviseur: (state) => state.Menages.MenagesDuSuperviseur,
    }),
  },
};
</script>

<style scoped></style>
